import { ColumnSelectionFilter } from './ColumnSelectionFilter';
import {
  useProviderTableStore,
  initialProviderColumns,
} from 'views/pages/Admin/Provider/Filters/filters.store';
import { Button } from '@mui/material';
import { ColumnPreferencesConfig } from '@common/types';

type ProviderColumnKey =
  | 'name'
  | 'guide_certified'
  | 'city'
  | 'region'
  | 'clinical_leader'
  | 'supervising_physician'
  | 'partner_name'
  | 'practice_name'
  | 'assigned_cms'
  | 'provider_specialty'
  | 'status';

const PROVIDER_TABLE_COLUMN_LABELS: Record<ProviderColumnKey, string> = {
  name: 'Name',
  guide_certified: 'GUIDE Certified',
  city: 'City / State',
  region: 'Region',
  clinical_leader: 'Clinical Leader',
  supervising_physician: 'Supervising Physician',
  partner_name: 'Partner',
  practice_name: 'Practice',
  assigned_cms: 'Care Managers',
  provider_specialty: 'Specialty',
  status: 'Status',
};

const ALL_FIELDS = initialProviderColumns.map(
  c => c.field,
) as ProviderColumnKey[];

export const ProviderTableColumnSelectionFilter = ({
  hideText,
}: {
  hideText?: boolean;
}) => {
  const hiddenColumns = useProviderTableStore(s => s.hiddenColumns);
  const setHiddenColumns = useProviderTableStore(s => s.setHiddenColumns);

  const columns: Partial<Record<ProviderColumnKey, ColumnPreferencesConfig>> =
    Object.fromEntries(
      ALL_FIELDS.map((field, index) => [
        field,
        {
          column_display: hiddenColumns.includes(field) ? 'hidden' : 'display',
          column_order: index,
          column_size: 160,
        } satisfies ColumnPreferencesConfig,
      ]),
    );

  const handleSelectionChange = (
    selection: Partial<Record<ProviderColumnKey, ColumnPreferencesConfig>>,
  ) => {
    setHiddenColumns(
      ALL_FIELDS.filter(field => selection[field]?.column_display === 'hidden'),
    );
  };

  return (
    <ColumnSelectionFilter
      name='provider_table_columns'
      label='Columns'
      hideText={hideText}
      columns={columns}
      columnLabels={PROVIDER_TABLE_COLUMN_LABELS}
      onChange={handleSelectionChange}
      footerAction={
        <Button color='primary' onClick={() => setHiddenColumns([])}>
          RESET
        </Button>
      }
    />
  );
};
